// Note: prompts are intentionally phrased as natural-language questions/requests
// rather than terse imperatives ("List…", "Show…"). Short imperative wording
// pushes gemini-flash-lite into Python-REPL completion mode and triggers
// MALFORMED_FUNCTION_CALL responses (observed in prod logs as
// `print(default_api.list_X())<ctrl98>`). Conversational phrasing reliably
// produces structured function calls. Keep new entries in this style.
export const MCP_SAFE_AGENT_PROMPTS: string[] = [
  'What resumes do I have on file?',
  'What job descriptions are open right now?',
  'How much of my plan have I used this month?',
  'Find top 5 candidates for a Python backend role',
  'Find top 5 candidates for a data engineer role',
  'Find top 5 candidates for a machine learning engineer role',
  'Match resumes for a senior frontend engineer role',
  'Help me save a new job description for a Senior Backend Engineer with Python and FastAPI',
];

export const TOPBAR_AGENT_PROMPT_ROTATION: string[] = [
  'What resumes do I have on file?',
  'What job descriptions are open right now?',
  'How much of my plan have I used this month?',
  'Find top 5 candidates for a Python backend role',
  'Find top 5 candidates for a data engineer role',
];
